import dateFormatter from '@/services/functions/date-filter';

export default function createOfferFromResource(data) {
  return {
    id: data.id,
    name: data.name,
    slug: data.slug,
    bottomBanner: data.bottom_banner,
    topBanner: data.top_banner,
    manager: data.manager,
    isArchived: data.is_archived,
    createdAt: dateFormatter(data.created_at),
    validFrom: dateFormatter(data.valid_from),
    validTo: dateFormatter(data.valid_to),
    isCountdownEnabled: data.is_countdown_enabled,
    services: (data.services || []).map((offerServiceResource) => ({
      id: offerServiceResource.id,
      name: offerServiceResource.name,
      discountPercent: Number(offerServiceResource.discount_percent) * 100,
    })),
    status: data.status,
    actions: {
      completable: data.actions.completable,
      archivable: data.actions.archivable,
      editable: data.actions.editable,
      unarchivable: data.actions.unarchivable,
    },
  };
}
